import {
    TokenAmount,
    TransactionDetailRow,
    TransactionFeeSection,
    TransactionDialogContent,
    TransactionSection,
} from "@/components";
import { useWithdrawUnwoundTransaction } from "@/hooks";
import { Divider } from "@/components";
import { TOKEN_IDS } from "@/types";
import { useCallback, useMemo } from "react";
import { GENERIC_TRANSACTION_EVENTS, genericTransactionEventEmitter } from "@/events";

export interface WithdrawUnwoundTransactionProps {
    unwindingTimestamp: number;
    amount: number;
    onClose?: () => void;
}

export function WithdrawUnwoundTransaction({ unwindingTimestamp, amount, onClose }: WithdrawUnwoundTransactionProps) {
    const { gasPriceUSD, executeWithdrawUnwoundTransaction, isLoading } = useWithdrawUnwoundTransaction({
        unwindingTimestamp,
    });

    const handleConfirm = useCallback(async () => {
        try {
            await executeWithdrawUnwoundTransaction().then(() => onClose?.());
        } catch (e) {
            console.error(e);
            genericTransactionEventEmitter.emit(GENERIC_TRANSACTION_EVENTS.FAILED, {
                error: `${e}`,
            });
        }
    }, [executeWithdrawUnwoundTransaction, onClose]);

    // TODO: Come up with proper way to indicate move from liUSD to iUSD
    const WITHDRAW_TEXT = useMemo(() => <TokenAmount amount={amount} tokenId={TOKEN_IDS.IUSD} size="md" />, [amount]);
    const CONFIRM_TEXT = "Confirm Withdraw";

    return (
        <TransactionDialogContent
            onClose={onClose}
            onConfirm={handleConfirm}
            isLoading={isLoading}
            confirmText={CONFIRM_TEXT}
            className="min-w-sm max-w-md w-[420px] flex flex-col justify-start py-4"
        >
            <TransactionSection>
                <TransactionDetailRow label="Locked position" value={WITHDRAW_TEXT} />
            </TransactionSection>

            <span className="min-h-6"></span>

            <Divider />
            <TransactionFeeSection gasPriceUSD={gasPriceUSD} />
        </TransactionDialogContent>
    );
}
